import { render, staticRenderFns } from "./TestSubject.vue?vue&type=template&id=742801cb&"
import script from "./TestSubject.vue?vue&type=script&lang=js&"
export * from "./TestSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports